module.exports = __webpack_public_path__ + "static/media/grocery-slide-4.c450b367.png";